import {Fragment} from "react";
import BasicModal from "../../../../../../../common/BasicModal";
import ConstructiveFeedbackContainer from "./ConstructiveFeedbackContainer";

export default function ConstructiveFeedbackModal({title, open, handleClose}) {

    return (
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '700px'}}
                handleClose={handleClose}>

                <ConstructiveFeedbackContainer
                    handleClose={handleClose}
                />
            </BasicModal>
        </Fragment>
    )
}